// extracted by mini-css-extract-plugin
export default {"title":"flORaY","subtitle":"ED1coT","create-button":"ZSAM2K","createButton":"ZSAM2K","search-sort":"MqaYeq","searchSort":"MqaYeq","sortDropdown":"qqi47i","mobileSearch":"CHea__"};